import { render, staticRenderFns } from "./ExemptionExtendDeadline.vue?vue&type=template&id=8efc6234&scoped=true&"
import script from "./ExemptionExtendDeadline.vue?vue&type=script&lang=js&"
export * from "./ExemptionExtendDeadline.vue?vue&type=script&lang=js&"
import style0 from "./ExemptionExtendDeadline.vue?vue&type=style&index=0&id=8efc6234&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8efc6234",
  null
  
)

export default component.exports